import { __assign, __rest } from "tslib";
import React, { memo } from 'react';
import { Checkbox, Flex } from '@marvelapp/ui';
import EditableText from '../EditableText';
import Highlighter from '../Highlighter';
import ReadOnlyTitle from '../ReadOnlyTitle';
import CardHead from './CardHead';
import CardInfo from './CardInfo';
import LockIcon from './LockIcon';
import { CardBlock, Cards, TopLeft, TopLeftIcon } from './styles';
function CardInner(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(CardHead, __assign({}, props, { className: "inner-card-block not-selectable" })),
        !props.isDragged && (React.createElement(React.Fragment, null,
            props.info || (React.createElement(CardInfo, { label: props.label, owner: props.owner, secondaryCTAs: props.secondaryCTAs, showEmail: props.showEmail, showTimestamp: props.showTimestamp, updated: props.updated, workspace: props.workspace })),
            props.isEditable ? (React.createElement(Flex, { justifyContent: "center" },
                React.createElement(EditableText, { "data-testid": "project-screen-editable-text", fontSize: 14, hasError: props.hasError, lineHeight: 1.5, onSaveValue: props.onSaveTitle, searchWords: props.searchWords || [], textAlign: "center", value: props.title }))) : (React.createElement(ReadOnlyTitle, { "data-testid": "project-screen-title", fontSize: 14 },
                React.createElement(Highlighter, { searchWords: props.searchWords || [], testId: props.titleTestId, textToHighlight: props.title })))))));
}
var MemoizedCardInner = memo(CardInner);
/** @type any */
var Card = function (_a) {
    var cursor = _a.cursor, lockedText = _a.lockedText, onClick = _a.onClick, opacity = _a.opacity, isSelected = _a.isSelected, isSelectable = _a.isSelectable, onSelect = _a.onSelect, children = _a.children, restProps = __rest(_a, ["cursor", "lockedText", "onClick", "opacity", "isSelected", "isSelectable", "onSelect", "children"]);
    return (
    // isSelected is passed to the CardBlock component to avoid re-rendering MemoizedCardInner and rely
    // on pure CSS to select .inner-card-block and style it directly
    React.createElement(CardBlock, { cursor: cursor, "data-testid": "card-block", isSelected: isSelected, onClick: onClick, opacity: opacity },
        React.createElement(MemoizedCardInner, __assign({ locked: lockedText }, restProps)),
        lockedText && (React.createElement(TopLeftIcon, { className: restProps.primaryCTAs ? 'with-cta' : '' },
            React.createElement(LockIcon, { lockedText: lockedText }))),
        isSelectable && onSelect && (React.createElement(TopLeft, { className: "not-selectable", isSelected: isSelected },
            React.createElement(Checkbox, { "data-testid": "card-select-checkbox", display: "block", isChecked: isSelected, kind: "whiteToGreen", onChange: onSelect, size: 24 }))),
        children));
};
Card.defaultProps = {
    bg: 'snow',
    borderRadius: 2,
};
export default React.memo(Card);
export { Cards };
